import { Stack } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockFooterProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    display: 'flex',
    height: '3.75rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: colorSchemeTokens.outlineVariant,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    backgroundColor: colorSchemeTokens.surfaceContainerHigh,
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
  },
});

export const ContentBlockFooter: React.FC<IContentBlockFooterProps> = ({
  sx,
  children,
}) => (
  <div {...stylex.props(styles.host, sx)}>
    <Stack horizontal gap={2}>
      {children}
    </Stack>
  </div>
);
